export default __webpack_public_path__ + "static/media/download-icon.1ce72c89.gif";